import { Bug, Sparkles, FlaskConical } from 'lucide-react';

export const TASK_TYPE_COLORS = { bug: '#DC2626', feature: '#8B5CF6', qa: '#0891B2' };
export const TASK_TYPE_LABELS = { bug: 'Bug', feature: 'Feature', qa: 'QA' };
export const TASK_TYPE_ICONS = { bug: Bug, feature: Sparkles, qa: FlaskConical };

export const TASK_TYPE_OPTIONS = [
  { value: 'bug', label: 'Bug', color: TASK_TYPE_COLORS.bug, icon: Bug },
  { value: 'feature', label: 'Feature', color: TASK_TYPE_COLORS.feature, icon: Sparkles },
  { value: 'qa', label: 'QA', color: TASK_TYPE_COLORS.qa, icon: FlaskConical },
];
